__webpack_require__.p = "https://assets.canny.io/eb0ca36d44ca54f5a599c63ae4d75182eba7670f/";